import { render, staticRenderFns } from "./PerfilPerson.vue?vue&type=template&id=a9270120&scoped=true&functional=true&"
import script from "./PerfilPerson.vue?vue&type=script&lang=js&"
export * from "./PerfilPerson.vue?vue&type=script&lang=js&"
import style0 from "./PerfilPerson.vue?vue&type=style&index=0&id=a9270120&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "a9270120",
  null
  
)

export default component.exports